import { Button as e, Drawer as t } from "@systemeio/components";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { XCloseIcon as i } from "@systemeio/icons";
//#region src/components/content-controls/toolbar-drawer.tsx
function a({ children: a, contentClassName: o, onOpenChange: s, open: c, title: l, trigger: u }) {
	return /* @__PURE__ */ r(t.Root, {
		onOpenChange: s,
		open: c,
		children: [/* @__PURE__ */ n(t.Trigger, { render: u }), /* @__PURE__ */ r(t.Popup, {
			backdropProps: { forceRender: !0 },
			children: [/* @__PURE__ */ n(t.Header, { children: /* @__PURE__ */ r("div", {
				className: "flex w-full items-start gap-2.5",
				children: [/* @__PURE__ */ n(t.Title, {
					className: "min-w-0 flex-1",
					children: l
				}), /* @__PURE__ */ n(t.Close, {
					"aria-label": "Close",
					render: /* @__PURE__ */ n(e, {
						size: "icon-sm",
						variant: "ghost-gray"
					}),
					children: /* @__PURE__ */ n(i, {})
				})]
			}) }), /* @__PURE__ */ n(t.Content, {
				className: o,
				children: a
			})]
		})]
	});
}
//#endregion
export { a as ToolbarDrawer };
